// material-ui
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// project imports
import MainCard from "components/MainCard";
import SimpleBar from "components/third-party/SimpleBar";
import { ISkillWiseMembersModel } from "../../api/types";
import { Box, Typography } from "@mui/material";

// =========================|| DATA WIDGET - Industry Wise Members ||========================= //

type Props = {
  data: ISkillWiseMembersModel[];
};

export default function SkillWiseMembers({ data }: Props) {
  return (
    <MainCard content={false}>
      <TableContainer sx={{ mt: 0, maxHeight: 340 }}>
        <SimpleBar sx={{ height: 290 }}>
          <Table size="small" aria-label="a dense table">
            <TableHead
              sx={{
                position: "sticky",
                top: -1,
                zIndex: 2,
              }}
            >
              <TableRow>
                <TableCell sx={{ pl: 3 }}>Skills</TableCell>
                <TableCell align="right" sx={{ pr: 3 }}>
                  Members
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data[0] != null ? (
                <>
                  {data?.map((row, index) => (
                    <TableRow hover key={index}>
                      <TableCell>{row.skill}</TableCell>
                      <TableCell align="right" sx={{ pr: 3 }}>
                        {row.members}
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              ) : (
                <>
                  <Box sx={{ justifyItems: "center", ml: 15, mt: 12 }}>
                    <Typography>No record found!!</Typography>
                  </Box>
                </>
              )}
            </TableBody>
          </Table>
        </SimpleBar>
      </TableContainer>
    </MainCard>
  );
}
